import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import { UntypedFormGroup, AbstractControl, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JsonEditorOptions, JsonEditorComponent as AngJsonEditorComponent, JsonEditorMode, NgJsonEditorModule } from 'ang-jsoneditor';

@Component({
    selector: 'aware-ui-json-editor',
    templateUrl: './json-editor.component.html',
    styleUrls: ['./json-editor.component.scss'],
    standalone: true,
    imports: [NgJsonEditorModule, FormsModule, ReactiveFormsModule],
})
export class JsonEditorComponent implements OnInit, OnDestroy {
    @Input() control: AbstractControl;
    @Input() modes: JsonEditorMode[] = ['code', 'tree'];

    get formControl(): UntypedFormControl {
        return this.control as UntypedFormControl;
    }

    editorOptions: JsonEditorOptions;
    form: UntypedFormGroup;

    @ViewChild(AngJsonEditorComponent) jsonEditor: JsonEditorComponent;

    constructor() {
        this.editorOptions = new JsonEditorOptions();
        this.editorOptions.mode = 'code';
        this.editorOptions.modes = this.modes;
        this.editorOptions.mode = 'code';
    }

    ngOnInit() {}

    ngOnDestroy() {}

    isValidJson() {
        // return true;
        return this.jsonEditor.isValidJson();
    }
}
